import { useState } from "react";
import { Button } from "@/components/ui/button";
import { signInWithGoogle } from "@/lib/firebase";
import { Layout } from "@/components/layout/Layout";

export default function FirebaseTestPage() {
  const [result, setResult] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleGoogleSignIn = async () => {
    setLoading(true);
    setError(null);
    setResult(null);
    
    try {
      const signInResult = await signInWithGoogle();
      setResult(signInResult);
      
      // Get token if user exists
      if (signInResult?.user) {
        const token = await signInResult.user.getIdToken();
        console.log("Firebase ID Token:", token.substring(0, 20) + "...");
        
        // Now try to authenticate with our backend
        const response = await apiRequest('GET', 'auth/google', {
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            token,
            email: signInResult.user.email,
            displayName: signInResult.user.displayName || "",
          }),
        });
        
        const data = await response.json();
        console.log("Backend response:", data);
      }
    } catch (err: any) {
      console.error("Google sign-in error:", err);
      setError(err.message || "An error occurred during Google sign-in");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="container py-12">
        <div className="max-w-md mx-auto">
          <h1 className="text-2xl font-bold mb-6">Firebase Authentication Test</h1>
          
          <div className="space-y-6">
            <Button 
              onClick={handleGoogleSignIn} 
              disabled={loading}
              className="w-full"
            >
              {loading ? "Connecting..." : "Test Google Sign-In"}
            </Button>
            
            {error && (
              <div className="p-4 bg-red-50 border border-red-200 rounded-md text-red-700">
                <p className="font-medium">Error</p>
                <p className="text-sm">{error}</p>
              </div>
            )}
            
            {result && (
              <div className="p-4 bg-green-50 border border-green-200 rounded-md">
                <p className="font-medium text-green-700">Success!</p>
                <div className="mt-2 text-sm">
                  <p><span className="font-medium">User ID:</span> {result.user?.uid || "N/A"}</p>
                  <p><span className="font-medium">Email:</span> {result.user?.email || "N/A"}</p>
                  <p><span className="font-medium">Display Name:</span> {result.user?.displayName || "N/A"}</p>
                </div>
              </div>
            )}
            
            <div className="p-4 bg-blue-50 border border-blue-200 rounded-md text-blue-700 text-sm">
              <p>Check the browser console for more detailed information.</p>
              <p className="mt-2">This page is purely for testing the Firebase authentication flow.</p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}